import "externalized-styles-chunk.css";
// extracted by mini-css-extract-plugin
export default {"icon_wrapper":"icon_wrapper_e7e2bb8b","icon_unit":"icon_unit_e7e2bb8b","icon_block":"icon_block_e7e2bb8b","icon_with-loader":"icon_with-loader_e7e2bb8b"};